import { pickBy } from "lodash";
import { DataTableSortStatus } from "mantine-datatable";

import { ClikDataFilter } from "../../graphql/generated.ts";
import {
  ClikDataOrderBy,
  LimitRequestOrderBy,
} from "../../graphql/generated.ts";
import { getApiOrderBy } from "../../utils/api.ts";
import { getDateTimeRangeFilter } from "../../utils/filter.ts";
import { FiltersValue } from "./types.ts";

export const geClikDataApiFilter = (value: FiltersValue): ClikDataFilter => {
  return pickBy({
    naeDate: value.naeDate && getDateTimeRangeFilter(value.naeDate),
    enquiryType: value.enquiryType && { equals: value.enquiryType },
    limitRequest: pickBy({
      companyId: value.companyName?.length && {
        in: value.companyName.map((c) => Number(c)),
      },
      limitRequestType: value.limitRequestType && {
        equals: value.limitRequestType,
      },
    }),
  });
};

export const getClikDataApiSort = (
  tableSort: DataTableSortStatus
): ClikDataOrderBy => {
  const { companyName, ...apiSort } = getApiOrderBy(tableSort);
  let limitRequest: LimitRequestOrderBy | undefined = undefined;
  if (companyName) {
    limitRequest = { company: { name: companyName } };
  }
  return {
    ...apiSort,
    limitRequest,
  };
};
